import { SPACES } from "@/lib/studio";

const OPTIONS = [{ id: null, label: "No preference" }, ...SPACES.map((s) => ({ id: s.id, label: s.id }))];

export const SpacePicker = ({ value, onChange }) => (
  <div className="grid grid-cols-2 gap-3" data-testid="space-picker">
    {OPTIONS.map((o) => {
      const active = value === o.id;
      return (
        <button
          key={o.label}
          type="button"
          onClick={() => onChange(o.id)}
          data-testid={`space-option-${o.label.toLowerCase().replace(/\s+/g, "-")}`}
          className={`rounded-md border px-4 py-3 text-left text-sm font-medium transition-[border-color,background-color,color] duration-200 ${
            active ? "border-[#FF3333] bg-[#FF3333]/10 text-white" : "border-white/10 text-zinc-400 hover:border-white/30 hover:text-white"
          }`}
        >
          {o.label}
        </button>
      );
    })}
  </div>
);
